import React, { Component } from 'react';
// import logo from './logo.svg';
import { Row, Grid, Navbar } from 'react-bootstrap';
import './App.css';
import ServersList from './components/ServersList/ServersList.js';

const site_name = 'Redwood Server Manager';

class App extends Component {
  render() {
    return (
      <div>
        <Navbar inverse fixedTop>
          <Grid>
            <Navbar.Header>
              <Navbar.Brand>
                <a href="/">{site_name}</a>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
          </Grid>
        </Navbar>
        <Grid bsClass="container serversContainer">
          <Row>
            <h1>Redwood Servers</h1>
            <ServersList />
          </Row>
        </Grid>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js